(function () {
  const countNumbersElems = document.querySelectorAll("[data-count-numbers]");
  if (!countNumbersElems) return;

  countNumbersElems.forEach((countNumbersElem) => {
    const countNumberItems = countNumbersElem.querySelectorAll("[data-count-number]");

    countNumberItems.forEach((item, index) => {
      // Ustawienie opacity: 1 dla pierwszego elementu
      if (index === 0) {
        item.classList.add("active");
      }

      // Pobranie tekstu z elementu
      const text = item.textContent;

      // Wyczyszczenie zawartości elementu
      item.textContent = "";

      // Przekształcenie każdej litery w <span>
      text.split("").forEach((letter) => {
        const span = document.createElement("span");
        if (index === 0) {
          span.classList.add("active");
        }
        span.setAttribute("data-count-number-sign", "");
        span.textContent = letter;

        item.appendChild(span);
      });
    });
  });
})();

(function () {
  function activeCount(element) {
    const countNumbersElems = document.querySelectorAll("[data-count-numbers]");
    countNumbersElems.forEach((countNumbersElem) => {
      const countNumberItems = countNumbersElem.querySelectorAll("[data-count-number]");

      // Off element
      countNumberItems.forEach((item) => {
        if (item.classList.contains("active")) {
          setTimeout(() => {
            item.classList.remove("active");
          }, 330);
          let signs = item.querySelectorAll("[data-count-number-sign]");

          signs.forEach((sign, signIndex) => {
            setTimeout(() => {
              sign.classList.add("off");
              sign.classList.remove("active");
              setTimeout(() => {
                sign.classList.remove("off");
              }, 330);
            }, signIndex * 15);
          });
        }
      });

      // on element

      setTimeout(() => {
        countNumberItems.forEach((item, index) => {
          if (element === index) {
            item.classList.add("active");
            let signs = item.querySelectorAll("[data-count-number-sign]");

            signs.forEach((sign, signIndex) => {
              setTimeout(() => {
                sign.classList.add("active");
              }, signIndex * 15);
            });
          }
        });
      }, 300);
    });
  }

  setTimeout(() => {
    activeCount(1);
  }, 2300);

  setTimeout(() => {
    activeCount(2);
  }, 3900);
})();
